import React from "react";
import { VERSION } from "../../version";

// Version de la aplicacion en el footer (src/version.js)
export default function VersionApp() {
  return (
    <p className="blanco small" style={{ opacity: 0.6 }}>
      Versión {VERSION}
    </p>
  );
}
